module.exports = __webpack_public_path__ + "images/4-small.png";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/img/paypal/4-small.png
 ** module id = 574
 ** module chunks = 0
 **/